import computeScrollIntoView from 'compute-scroll-into-view'

const FOCUSABLE_SELECTOR =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'

function matches ($el, selector) {
  if ($el.matches) {
    return $el.matches(selector)
  } else if ($el.msMatchesSelector) {
    return $el.msMatchesSelector(selector)
  } else if ($el.webkitMatchesSelector) {
    return $el.webkitMatchesSelector(selector)
  }
}

export default function scroll (
  $el,
  {
    scrollMode = 'if-needed',
    block = 'start',
    inline = 'nearest',
    offset = 0,
    smooth = 'true',
    history = 'none'
  } = {}
) {
  function onClick (e) {
    e.preventDefault()
    let href = $el.getAttribute('href')
    scrollTo(href, {
      scrollMode,
      block,
      inline,
      offset,
      smooth,
      history
    })
  }

  function onChange () {
    if ($el.value) {
      scrollTo(`#${$el.value}`, {
        scrollMode,
        block,
        inline,
        offset,
        smooth,
        history
      })
    }
  }

  if ($el.tagName === 'SELECT') {
    $el.addEventListener('change', onChange)
    return () => $el.removeEventListener('change', onChange)
  }
  $el.addEventListener('click', onClick)
  return () => $el.removeEventListener('click', onClick)
}

export function scrollTo (
  href,
  {
    scrollMode = 'if-needed',
    block = 'start',
    inline = 'nearest',
    offset = 0,
    smooth = 'true',
    history = 'none'
  } = {}
) {
  let $target = typeof href === 'string' ? document.querySelector(href) : href

  if (!$target) {
    throw new Error(`Couldn’t find element for href ${href}`)
  }

  let reduceMotion =
    'matchMedia' in window &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  let behavior = smooth === 'true' && !reduceMotion ? 'smooth' : 'auto'

  if (history !== 'none') {
    window.history[`${history}State`]({}, '', href)
  }

  let actions = computeScrollIntoView($target, {
    scrollMode,
    block,
    inline
  })

  if (actions.length) {
    let $offset = document.querySelector('[data-scroll-offset]')
    if ($offset) offset += $offset.offsetHeight
  }

  let $$focusable = matches($target, FOCUSABLE_SELECTOR)
    ? [$target]
    : $target.querySelectorAll(FOCUSABLE_SELECTOR)

  if ($$focusable.length) {
    actions.forEach(action => {
      action.originalTop = action.el.scrollTop
      action.originalLeft = action.el.scrollLeft
    })

    $$focusable[0].focus()

    actions.forEach(({ el: $el, originalTop }) => {
      $el.scrollTop = originalTop
    })
  }

  actions.forEach(({ el: $el, top, left }) => {
    try {
      $el.scroll({
        top: top - offset,
        left: left,
        behavior
      })
    } catch (_) {
      $el.scrollTop = top - offset
      $el.scrollLeft = left
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/components/scroll.js